// extracted by mini-css-extract-plugin
export var btn = "SendEmailForm-module--btn--50768";
export var errorText = "SendEmailForm-module--errorText--540da";
export var form = "SendEmailForm-module--form--695f9";
export var formItem = "SendEmailForm-module--formItem--f056d";
export var input = "SendEmailForm-module--input--cfc3b";
export var label = "SendEmailForm-module--label--78b89";